/**
 * Return `true` if environment is production.
 * @returns {boolean}
 */
export function isProd() {
  return window.location.hostname === 'nobilis.fr';
}
